import React from 'react'

const Footer = () => {
  return (
    <div id='footer'>
      <hr/>
      <h2>2020 <span className="purple fs-45">J</span>ob <span className="purple fs-45">R</span>ecover</h2>
      <p>Developed by <a target="_blank" rel='noreferrer' href="https://advaithm26.github.io">Advaith Malka</a>, <a href="https://sritanmotati.github.io" rel='noreferrer' target="_blank">Sritan Motati</a>, 
      and <a href="https://realtechnerd.github.io" rel='noreferrer' target="_blank">Nithil Krishnaraj</a>.</p>
    </div>
  )
}

export default Footer
